import React, { useEffect, useState } from "react";
import { NumberDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { IEditModeValueEditor } from "./Common";
import { UINumberList } from "../BuildlingBlocks/UINumberList";
import { TextField } from "@mui/material";

export { DisplayModeValueEditor as DisplayModeNumberValueEditor } from "./DisplayModeRender";

export const EditModeNumberValueEditor = React.forwardRef<HTMLElement, IEditModeValueEditor>(
    (props: IEditModeValueEditor, ref) => {
        if (props.forData.list) {
            return (
                <NumberListEditor
                    {...props}
                    ref={ref}
                />
            );
        }

        return (
            <NumberEditor
                {...props}
                ref={ref}
            />
        );
    },
);

const NumberEditor = React.forwardRef<HTMLElement, IEditModeValueEditor>(
    ({ value, forData, onUpdate }: IEditModeValueEditor, ref) => {
        let datadef = forData as NumberDataDefinition;

        const [val, setVal] = useState<number>();

        const [error, setError] = useState<string | undefined>();

        useEffect(() => {
            let v = (forData as NumberDataDefinition).convert(value);
            setVal(v);
        }, [value, setVal, forData]);

        function setValue(newValue?: number) {
            setVal(newValue);
            setError("");

            if (newValue === 0 || newValue) onUpdate(datadef.convert(newValue));
            else onUpdate(undefined);
        }

        const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            if (event.target.value === "") setValue(undefined);

            const validNumber = new RegExp(/^-?[0-9]\d*(\.\d+)?$/);
            if (validNumber.test(event.target.value)) {
                if (event.target.value !== "") {
                    let newValue = Number(event.target.value as string);

                    if (!isNaN(newValue) && event.target.value.endsWith(".") && datadef.allowDecimals) {
                        setValue(newValue);
                        return;
                    }

                    let error: string | undefined = undefined;

                    if (datadef.upperBounds !== undefined) {
                        if (newValue > datadef.upperBounds) error = "Value must be below " + datadef.upperBounds;
                    }

                    if (!error && datadef.lowerBounds !== undefined) {
                        if (newValue > datadef.lowerBounds) error = "Value must be greater than " + datadef.lowerBounds;
                    }

                    if (!error) setValue(newValue);
                    else setError(error);
                } else {
                    setValue(undefined);
                }
            } else {
                if (event.target.value !== "") {
                    setError("only numbers are allowed");
                }
            }
        };

        let placeholder: string | undefined = datadef.allowDecimals ? "0.00" : "00";

        return (
            <TextField
                variant={"outlined"}
                size={"small"}
                value={val === 0 || val ? val : ""}
                onChange={onChange}
                placeholder={placeholder}
                type="number"
                inputRef={ref}
                data-testid={`ValueEditor-Edit-number`}
                inputProps={{ style: { textAlign: "right" } }}
                error={!!error}
                helperText={error}
            />
        );
    },
);

const NumberListEditor = React.forwardRef<HTMLElement, IEditModeValueEditor>(
    // eslint-disable-next-line
    ({ value, onUpdate }: IEditModeValueEditor, ref) => {
        return (
            <UINumberList
                inputRef={ref}
                value={Array.isArray(value) && typeof value !== "string" ? value : value ? [value] : []}
                onChange={(v) => onUpdate(v)}
            />
        );
    },
);
